import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getAllVendors = createAsyncThunk(
  "VendorsList/getAllVendors",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/vendors?pageNumber=${
          data.pageNumber
        }&pageSize=${data.pageSize}&sortBy=name&sortOrder=asc&search=${
          data.search || ""
        }`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data?.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
